var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.813 1.98519C13.813 1.89187 13.7769 1.80237 13.7126 1.73639C13.6484 1.6704 13.5612 1.63333 13.4704 1.63333H1.95926C1.8684 1.63333 1.78126 1.6704 1.71701 1.73639C1.65276 1.80237 1.61667 1.89187 1.61667 1.98519V11.837C1.61667 11.9304 1.65276 12.0198 1.71701 12.0858C1.78126 12.1518 1.8684 12.1889 1.95926 12.1889H13.4704C13.5612 12.1889 13.6484 12.1518 13.7126 12.0858C13.7769 12.0198 13.813 11.9304 13.813 11.837V1.98519ZM14.4296 7.49322L17.65 10.8006V3.02159L14.4296 6.329V7.49322ZM18.2667 1.49259V12.3296L14.4296 8.38889V11.837C14.4296 12.0983 14.3286 12.3489 14.1487 12.5337C13.9688 12.7184 13.7248 12.8222 13.4704 12.8222H1.95926C1.70485 12.8222 1.46086 12.7184 1.28096 12.5337C1.10106 12.3489 1 12.0983 1 11.837V1.98519C1 1.7239 1.10106 1.47331 1.28096 1.28855C1.46086 1.1038 1.70485 1 1.95926 1H13.4704C13.7248 1 13.9688 1.1038 14.1487 1.28855C14.3286 1.47331 14.4296 1.7239 14.4296 1.98519V5.43333L18.2667 1.49259Z",
    fill: "#16201D",
    stroke: "black",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLogo);
export default __webpack_public_path__ + "static/media/video-logo.3cbb9c31.svg";
export { ForwardRef as ReactComponent };